import React, { useCallback, useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { Alert, Card, btn, input } from "../../components/workforce/common";

const msg = (e) => e?.response?.data?.detail?.message || "Something went wrong.";

function Preferences() {
  const [p, setP] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/comms/notifications/preferences").then((r) => setP(r.data)).catch((e) => setErr(msg(e))); }, []);
  if (!p) return <Alert text={err} testid="nc-prefs-error" />;
  const toggle = (c) => api.put("/comms/notifications/preferences", { email_digest: { ...p.email_digest, [c]: !p.email_digest[c] } })
    .then((r) => { setP(r.data); setErr(""); }).catch((e) => setErr(msg(e)));
  return (
    <Card testid="nc-prefs" className="space-y-2">
      <h2 className="font-heading text-lg">Email digest</h2>
      <p className="text-xs" data-testid="nc-prefs-note">{p.note} Test accounts and switched-off delivery are never emailed.</p>
      <div className="flex flex-wrap gap-2">{p.categories.map((c) => (
        <label key={c} className="inline-flex items-center gap-2 min-h-[44px] px-2 border rounded">
          <input type="checkbox" checked={p.email_digest[c]} onChange={() => toggle(c)} data-testid={`nc-pref-${c}`} />{c.replace("_", " ")}</label>))}</div>
      <Alert text={err} testid="nc-prefs-error" />
    </Card>
  );
}

export default function NotificationCenter() {
  const [d, setD] = useState({ items: [], unread: 0 });
  const [f, setF] = useState({ unread: false, category: "" });
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get("/comms/notifications", { params: { unread: f.unread || undefined, category: f.category || undefined } })
    .then((r) => setD(r.data)).catch((e) => setErr(msg(e))), [f]);
  useEffect(() => { load(); }, [load]);
  const act = (p) => p.then(load).catch((e) => setErr(msg(e)));
  return (
    <AppShell title="Notifications" subtitle="In-app notifications are always on">
      <div className="mx-auto w-full max-w-[900px] px-4 space-y-4" data-testid="nc-page">
        <div className="flex flex-wrap items-end gap-2">
          <h1 className="font-heading text-xl mr-auto" data-testid="nc-unread">{d.unread} unread</h1>
          <label className="inline-flex items-center gap-2 min-h-[44px]"><input type="checkbox" checked={f.unread} onChange={() => setF({ ...f, unread: !f.unread })} data-testid="nc-filter-unread" />Unread only</label>
          <label htmlFor="nc-filter-category" className="text-sm">Category</label>
          <select id="nc-filter-category" className={`${input} w-auto`} value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} data-testid="nc-filter-category">
            <option value="">All</option>{["rfi", "change_order", "safety", "finance", "schedule", "procurement", "documents", "crm", "system"].map((c) => <option key={c} value={c}>{c.replace("_", " ")}</option>)}</select>
          <button type="button" className={btn} onClick={() => act(api.post("/comms/notifications-read-all", f.category ? { category: f.category } : {}))} data-testid="nc-read-all">Mark all read</button>
        </div>
        <Alert text={err} testid="nc-error" />
        {d.items.length === 0 && <p data-testid="nc-empty">Nothing here.</p>}
        <ul className="space-y-2">{d.items.map((n) => (
          <li key={n.id} className={`rounded border p-3 text-sm ${n.read ? "bg-white" : "bg-erf-cream border-erf-navy"}`} data-testid={`nc-item-${n.id}`}>
            <div className="flex flex-wrap justify-between gap-2"><strong>{n.subject}</strong><span className="text-xs">{n.category} · {n.created_at?.slice(0, 16).replace("T", " ")}</span></div>
            <p className="whitespace-pre-wrap">{n.body}</p>
            <button type="button" className={`${btn} mt-2`} onClick={() => act(api.post(`/comms/notifications/${n.id}/${n.read ? "unread" : "read"}`))} data-testid={`nc-toggle-${n.id}`}>{n.read ? "Mark unread" : "Mark read"}</button>
          </li>))}</ul>
        <Preferences />
      </div>
    </AppShell>
  );
}
